const ContactFooter = () => (
  <>
    {/* Contact Section */}
    <section
      id="contact"
      className="py-20 md:py-24 px-4 md:px-8"
      style={{ background: '#1e1e1e' }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-[#D4FF00] font-mono text-xs tracking-[0.4em] uppercase mb-3">Need Help?</p>
        <h2
          className="text-4xl md:text-5xl text-white uppercase tracking-widest mb-4"
          style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
        >
          CONTACT INFO
        </h2>
        <div className="h-px max-w-xs mx-auto bg-gradient-to-r from-transparent via-[#CE1126] to-transparent mb-12" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          <div
            className="border border-[#2a2a2a] p-8"
            style={{ background: '#161616' }}
          >
            <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4" style={{ background: '#CE1126' }}>
              <i className="ri-user-line text-2xl text-white" />
            </div>
            <h3
              className="text-white text-xl uppercase tracking-widest mb-2"
              style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
            >
              SHAUN
            </h3>
            <p className="text-[#888] font-mono text-xs uppercase tracking-widest mb-4">Order Coordinator</p>
            <a
              href="tel:9258583739"
              className="block text-[#D4FF00] font-mono text-xl tracking-widest hover:text-white transition-colors duration-200 cursor-pointer"
            >
              (925) 858-3739
            </a>
          </div>

          <div
            className="border border-[#2a2a2a] p-8"
            style={{ background: '#161616' }}
          >
            <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4" style={{ background: '#D4FF00' }}>
              <i className="ri-time-line text-2xl text-black" />
            </div>
            <h3
              className="text-white text-xl uppercase tracking-widest mb-2"
              style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
            >
              RESPONSE TIME
            </h3>
            <p className="text-[#888] font-mono text-xs uppercase tracking-widest mb-4">Order Processing</p>
            <p className="text-white font-mono text-sm leading-relaxed">
              Orders confirmed within 24 hrs of Venmo payment
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Footer */}
    <footer
      className="py-8 px-4 md:px-8 border-t border-[#2a2a2a]"
      style={{ background: '#111111' }}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/edited_fef8d5247c92ac9a1969d8377d67a28e_8129bb92.jpg"
            alt="Logo"
            className="w-8 h-8 object-contain"
          />
          <span
            className="text-white text-sm uppercase tracking-widest"
            style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
          >
            ZYN POUCH ORDERS
          </span>
        </div>
        <p className="text-[#444] font-mono text-xs text-center">
          Unofficial station supply service. Not affiliated with fire department operations.
        </p>
        <p className="text-[#444] font-mono text-xs">
          Payment via <span className="text-[#C0C0C0]">Venmo</span> only
        </p>
      </div>
    </footer>
  </>
);

export default ContactFooter;
